import React from 'react'
import { motion } from 'framer-motion'
import HeroSection from '../../molecules/Upskill/HeroSection'
import UpskillCoursesSection from '../../molecules/Upskill/UpskillCoursesSection'
import UpskillExpertiseSection from '../../molecules/Upskill/UpskillExpertiseSection'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'
import Constants from '../../../app/utils/constants'

const UpskillPage = () => {
  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: '-100px' },
    transition: { duration: 0.7, ease: 'easeIn' as const },
  }

  return (
    <main className="min-h-screen text-white" style={{ backgroundColor: colors.upskillPageBg }}>
      <motion.div {...fadeUp}>
        <HeroSection />
      </motion.div>

      <motion.div {...fadeUp}>
        <UpskillCoursesSection />
      </motion.div>

      <motion.div {...fadeUp}>
        <UpskillExpertiseSection />
      </motion.div>

      <motion.div {...fadeUp}>
        <Testimonial className="mx-auto mb-20 max-w-[90%]" data={Constants.upskillTestimonialsData} />
      </motion.div>

      <motion.div {...fadeUp}>
        <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
          <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
            <Message />
            <Questions />
          </div>
        </div>
      </motion.div>

        <Footer />
   
    </main>
  )
}

export default UpskillPage
